import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "styled-components"
import { BaseCSS, GridThemeProvider } from "styled-bootstrap-grid"
import { CookiesProvider } from "react-cookie"
import { useIntl } from "gatsby-plugin-react-intl"
import "normalize.css"

import "../../static/assets/fonts/scto-grotesk-a.css"
import GlobalStyle from "../styles/globalStyle"
import { lightTheme } from "../styles/globalTheme"
import { gridTheme } from "../styles"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ErpBanner from "../components/banners/ErpBanner"

const Layout = (props) => {
  const intl = useIntl()
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <CookiesProvider>
      <ThemeProvider theme={lightTheme}>
        <GridThemeProvider gridTheme={gridTheme}>
          <BaseCSS />
          <GlobalStyle />
          <div className="site" id="top">
            <div
              className={`site-content ${props.signet === " " ? "site-content--compact" : ""}`}
            >
              <Header
                siteTitle={data.site.siteMetadata.title}
                signet={props.signet}
                logo={props.logo}
                shortlinks={props.shortlinks}
                hideLangSwitch={props.hideLangSwitch}
                hideSearch={props.hideSearch}
                nav={props.nav}
              />
              <main
                id="main"
                role="main"
                aria-label={intl.formatMessage({
                  id: "accessibility.regions.content",
                })}
              >
                <ErpBanner
                  pageId={props.pageId}
                  forceLocale={props.forceLocale}
                />
                {props.children}
              </main>
            </div>
            <Footer
              forceLocale={props.forceLocale}
              translations={props.translations}
            />
          </div>
        </GridThemeProvider>
      </ThemeProvider>
    </CookiesProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  forceLocale: PropTypes.string,
  pageId: PropTypes.string.isRequired,
}

export default Layout
